var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label}},[_c('v-select',{staticClass:"custom-select",attrs:{"options":_vm.fontSizes()},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }